import React from 'react';
import { Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import { setCostingCodeValue } from './costingCodeUtils';

const findOption = (options, value) =>
  value ? options.find((o) => o.value === value) ?? { value, label: value } : null;

const DynamicCostingCodeFields = ({
  dimensions,
  values,
  onChange,
  optionMap = {},
  loading,
  disabled,
  colMd = 6
}) => {
  const activeDimensions = dimensions ?? [];

  if (!activeDimensions.length) return null;

  return activeDimensions.map((dimension) => {
    const dimensionCode = Number(dimension.dimensionCode);
    const value = values?.[dimensionCode] ?? null;
    const options = optionMap[dimensionCode] ?? [];
    const label = dimension.displayName ?? `Costing Code ${dimensionCode}`;
    const controlId = `costing-code-${dimensionCode}`;

    return (
      <Col md={colMd} className="mb-3" key={dimensionCode}>
        <Form.Label htmlFor={controlId}>{label}</Form.Label>
        {options.length > 0 ? (
          <Select
            inputId={controlId}
            options={options}
            value={findOption(options, value)}
            onChange={(opt) => onChange(setCostingCodeValue(values, dimensionCode, opt?.value ?? null))}
            isClearable
            isDisabled={loading || disabled}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        ) : (
          <Form.Control
            id={controlId}
            value={value ?? ''}
            disabled
            readOnly
            placeholder={loading ? `Loading ${label} options...` : `No options available for ${label}`}
          />
        )}
      </Col>
    );
  });
};

export default DynamicCostingCodeFields;
